import type { ICertificateCruiseLine } from '@share/common-types';

export function normalizeEligibleCruiseLines(value: unknown): ICertificateCruiseLine[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.flatMap((item, index) => {
    if (typeof item === 'string' || typeof item === 'number') {
      const name = String(item).trim();
      if (!name) {
        return [];
      }
      const parsedId = Number(name);
      return [
        {
          id: name,
          cruiseLineId: Number.isFinite(parsedId) ? parsedId : undefined,
          name,
        },
      ];
    }

    if (!item || typeof item !== 'object') {
      return [];
    }

    const record = item as Record<string, unknown>;
    const name = typeof record.name === 'string' ? record.name : '';
    const cruiseLineId =
      typeof record.cruiseLineId === 'number'
        ? record.cruiseLineId
        : Number(record.cruiseLineId);
    const id =
      record.id != null
        ? String(record.id)
        : Number.isFinite(cruiseLineId)
          ? String(cruiseLineId)
          : String(index);

    if (!name && !Number.isFinite(cruiseLineId)) {
      return [];
    }

    return [
      {
        id,
        cruiseLineId: Number.isFinite(cruiseLineId) ? cruiseLineId : undefined,
        name: name || String(cruiseLineId),
        logoUrl: typeof record.logoUrl === 'string' ? record.logoUrl : undefined,
        videoUrl: typeof record.videoUrl === 'string' ? record.videoUrl : undefined,
      },
    ];
  });
}

export function eligibleCruiseLineNames(lines: ICertificateCruiseLine[] | undefined): string[] {
  return (lines ?? []).map((line) => line.name).filter(Boolean);
}
